<template>
  <div>
    <br />
    <br />
    <div id="uoloaddiv2">
      <el-row>
        <el-button
          class="topbuttn"
          size="medium"
          icon="el-icon-circle-plus"
          @click="add_taskadd"
          type="primary"
        >创建任务</el-button>
        <el-button
          class="topbuttn"
          size="medium"
          icon="el-icon-star-on"
          @click="_get_triger_tasklist"
          type="primary"
        >手動刷新</el-button>
      </el-row>
      <br />
      <br />
      <el-table :data="tableDatatasklist" border>
        <el-table-column type="index" width="50px" label="编号"></el-table-column>
        <el-table-column prop="task_name" label="任务名字" width="300px"></el-table-column>

        <el-table-column prop="task_status" label="状态" width="100px"></el-table-column>
        <el-table-column fixed="right" label="[操作]-[启用]-[修改] " width="200px">
          <template slot-scope="scope">
            <el-button
              @click.native.prevent="deletetask(scope.$index, tableDatatasklist)"
              type="text"
              size="small"
            >移除</el-button>
            <el-switch
              active-value="1"
              inactive-value="0"
              v-model="tableDatatasklist[scope.$index].task_enable"
              @change="abletask(scope.$index, tableDatatasklist)"
            ></el-switch>
            <el-button
              @click.native.prevent="detailtask(scope.$index, tableDatatasklist)"
              type="text"
              size="small"
            >詳情</el-button>
            <!-- <el-button
					   @click.native.prevent="detailtask(scope.$index, tableDatatasklist)"
					   type="text"
					   size="small">
					   试听
            </el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div>
      <el-dialog :title="dialog_titel" :visible.sync="dialogVisible_addtask">
        <el-form ref="form" :model="form" label-width="80px" align="left">
          <el-form-item label="任务名字">
            <el-input v-model="form.name"></el-input>
          </el-form-item>
          <el-form-item label="任务类型">
            <el-select v-model="form.kind" placeholder="请选择任务类型" @change="kind_change">
              <el-tooltip class="item" effect="dark" content="定时触发启动" placement="right-start">
                <el-option label="定时任务" value="1"></el-option>
              </el-tooltip>
              <el-tooltip
                class="item"
                effect="dark"
                content="手动启动 或者 由报警信号触发"
                placement="right-start"
              >
                <el-option label="触发任务" value="2"></el-option>
              </el-tooltip>
            </el-select>
          </el-form-item>
          <el-form-item label="任务时间" v-if="timepickerVisible">
            <el-time-picker
              v-model="form.time"
              :editable="true"
              size="min"
              placeholder="任意时间点"
              style="width=200px"
            ></el-time-picker>
          </el-form-item>
          <el-form-item label="任务时长" v-if="time_len_visable">
            <el-tooltip
              class="item"
              effect="dark"
              content="为0时 播放时间为 音频文件播放完就结束,单位为秒"
              placement="right-start"
            >
              <el-input-number v-model="form.length" :min="0" :max="72000"></el-input-number>
            </el-tooltip>
          </el-form-item>
          <el-form-item label="任务周期">
            <el-checkbox-group v-model="form.week">
              <el-checkbox label="1" name="type">周一</el-checkbox>
              <el-checkbox label="2" name="type">周二</el-checkbox>
              <el-checkbox label="3" name="type">周三</el-checkbox>
              <el-checkbox label="4" name="type">周四</el-checkbox>
              <el-checkbox label="5" name="type">周五</el-checkbox>
              <el-checkbox label="6" name="type">周六</el-checkbox>
              <el-checkbox label="0" name="type">周日</el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <h3 style="text-align: center; margin: 50px 0 20px">选择需要播放的设备</h3>
          <div style="text-align: center">
            <el-transfer
              style="text-align: left; display: inline-block"
              v-model="form.value4"
              filterable
              :titles="['Source', 'Target']"
              :button-texts="['到左边', '到右边']"
              :format="{
								noChecked: '${total}',
								hasChecked: '${checked}/${total}'
							}"
              :data="form.data2"
            >
              <span slot-scope="{ option }">{{ option.label }}</span>
            </el-transfer>
          </div>
          <h3 style="text-align: center; margin: 50px 0 20px">选择任务音频文件</h3>
          <div style="text-align: center">
            <el-transfer
              style="text-align: left; display: inline-block"
              v-model="form.value5"
              filterable
              :titles="['所有文件', '播放文件']"
              :button-texts="['到左边', '到右边']"
              :format="{
								noChecked: '${total}',
								hasChecked: '${checked}/${total}'
							}"
              :data="form.data3"
            >
              <span slot-scope="{ option }">{{ option.label }}</span>
            </el-transfer>
          </div>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible_addtask = false">取 消</el-button>
          <el-button type="primary" @click="_save_task">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import axios from "axios";
axios.defaults.headers = {
  "Content-Type": "application/x-www-form-urlencoded;charset=UTF-8"
};
let Base64 = require("js-base64").Base64;
export default {
  data() {
    const generateData2 = _ => {
      const data = [];
      for (let i = 1; i <= 15; i++) {
        data.push({
          key: i,
          label: `备选项 ${i}`,
          disabled: false
        });
      }
      return data;
    };
    return {
      tableDatatasklist: [],
      dialogVisible_addtask: false,
      timepickerVisible: false,
      dialog_titel: "",
      time_len_visable: false,
      form: {
        name: "",
        kind: "2",
        date: "",
        date1: "",
        date2: "",
        time: "00:00",
        data2: [],
        data3: [],
        value4: [],
        value5: [],
        week: [],
        length: 0,
        tags_devices: [{ name: "设备1" }, { name: "设备1" }, { name: "设备1" }],
        music_files: []
      },
      value3: [],
      value2: []
    };
  },
  created() {
    this._get_triger_tasklist();
  },
  methods: {
    kind_change(data) {
      if (data === "1") {
        this.timepickerVisible = true;
      } else {
        this.timepickerVisible = false;
      }
    },
    str_pull(data) {
      let str = "";
      data.forEach((item, index) => {
        str += item;
        str += "|";
      });
      return str.substring(0, str.length - 1);
    },
    _get_triger_tasklist() {
      axios
        .get("/Get_list_of_trigertask.php")
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatatasklist = res.data.dataJson;
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    _save_task() {
      let dataout = new URLSearchParams();
      dataout.append("taskname", this.form.name);
      dataout.append("kind", this.form.kind);
      dataout.append("time", this.form.time);
      dataout.append("week", this.str_pull(this.form.week));
      dataout.append("filelist", this.str_pull(this.form.value5));
      dataout.append("seedlist", this.str_pull(this.form.value4));
      dataout.append("length", this.form.length);
      if (this.dialog_titel != "添加任务") {
        dataout.append("task_id", this.form.task_id);
        alert(this.dialog_titel);
        alert(this.form.task_id);
      }
      axios
        .post("/add_save_task.php", dataout)
        .then(
          function(res) {
            if (res.data.res) {
              this._get_triger_tasklist();
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
      this.dialogVisible_addtask = false;
    },
    add_taskadd() {
      this.dialog_titel = "添加任务";
      axios
        .get("/get_addtask_needs.php")
        .then(
          function(res) {
            if (res.data.res) {
              this.form.data2 = res.data.devices;
              this.form.data3 = res.data.files;
              this.form.data3.forEach((item, index) => {
                this.form.data3[index].label = Base64.decode(item.label);
              });
              this.dialogVisible_addtask = true;
              this.$forceUpdate();
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

    deletetask(index, rows) {
      this.$confirm(
        "此操作将永久删除该任務,是否继续?" + rows[index].task_name,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(function() {
          if (rows[index].task_status != 4) {
            this.$message({
              type: "warning",
              message: "请先禁用该任务"
            });
            return;
          }

          let task_id = rows[index].id;
          axios
            .get("/del_task.php", {
              params: {
                task_id: rows[index].id
              }
            })
            .then(
              function(res) {
                if (res.data.res) {
                  rows.splice(index, 1);
                  this._get_triger_tasklist();
                  this.$message({
                    type: "success",
                    message: "删除成功!" + filename
                  });
                }
              }.bind(this)
            )
            .catch(function(res) {
              console.log(res);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    detailtask(index, rows) {
      this.dialog_titel = "查看/编辑 任务";
      axios
        .get("/get_task_detail.php", {
          params: {
            task_id: rows[index].id
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this.form = res.data.dataJson;

              axios
                .get("/get_addtask_needs.php")
                .then(
                  function(res) {
                    if (res.data.res) {
                      this.form.data2 = res.data.devices;
                      this.form.data3 = res.data.files;
                      this.form.data3.forEach((item, index) => {
                        this.form.data3[index].label = Base64.decode(
                          item.label
                        );
                      });
                      this.dialogVisible_addtask = true;
                      this.$forceUpdate();
                    }
                  }.bind(this)
                )
                .catch(function(res) {
                  console.log(res);
                });
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },
    abletask(index, rows) {
      console.log(index);
      console.log(rows[index].task_name);
      console.log(rows[index].task_enable);
      let task_id = rows[index].id;
      axios
        .get("/Change_task_status.php", {
          params: {
            task_id: rows[index].id,
            task_enable: rows[index].task_enable
          }
        })
        .then(
          function(res) {
            if (res.data.res) {
              this._get_triger_tasklist_st(rows[index].task_enable, index);
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    },

    _get_triger_tasklist_st(e, i) {
      axios
        .get("/Get_list_of_trigertask.php")
        .then(
          function(res) {
            if (res.data.res) {
              this.tableDatatasklist = res.data.dataJson;
              if (e === "1") {
                this.$message({
                  type: "success",
                  message: "已生效!" + this.tableDatatasklist[i].task_name
                });
              } else {
                this.$message({
                  type: "success",
                  message: "已经禁用!" + this.tableDatatasklist[i].task_name
                });
              }
            }
          }.bind(this)
        )
        .catch(function(res) {
          console.log(res);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.topbuttn {
  width: 150px;
}
#uoloaddiv2 {
  width: 800px;
  margin-left: 40px;
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.el-button .el-switch {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/xxxvue/tigertask.vue